import { render } from "./icon_chart.svg?vue&type=template&id=5a5537b2?inline"
const script = {}
script.render = render

export default script